import styled from 'styled-components'

export const InitialMessageContainer = styled.div`
  font-weight: 600;
  margin: auto;
  color: ${({ theme }) => theme.token.colorText};
`

export default InitialMessageContainer
